import { render, staticRenderFns } from "./Safety1.vue?vue&type=template&id=f3afb914&scoped=true"
import script from "./Safety1.vue?vue&type=script&lang=js"
export * from "./Safety1.vue?vue&type=script&lang=js"
import style0 from "./Safety1.vue?vue&type=style&index=0&id=f3afb914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3afb914",
  null
  
)

export default component.exports